import type { RouterOutputs } from "@/trpc";

export function onboardingAccountValues({
  saved,
  healthcareRoles,
}: {
  saved: RouterOutputs["providerOnboarding"]["getSavedDetails"]["account"];
  healthcareRoles: RouterOutputs["healthcareProfessionalTypes"]["getAll"];
}) {
  const providerType = saved.providerType.trim().toLowerCase();
  const role = healthcareRoles.find((entry) =>
    [entry.id, entry.code, entry.name, ...entry.aliases].some(
      (value) => value?.toLowerCase() === providerType,
    ),
  );
  const { providerType: _providerType, ...values } = saved;
  return {
    ...values,
    healthcareProfessionalType: role?.id ?? "",
  };
}
